<form [formGroup]="form" xmlns="http://www.w3.org/1999/html">

    <!-- Actions -->

    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                <h1 class="title">{{ 'offer.add.action.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="openLeaveWithoutSubmitDialog()">
                    {{ 'offer.attribute.title.back.mono.value' | translate }}
                </button>

                @if(offerFormTabValidationService.currentItemIsLastItem) {

                    @if(form.get('onRequest').value) {

                        <!-- Enregistrer -->

                        <button class="btn_cta btn_little" type="button" [disabled]="!offerFormTabValidationService.isValid || !submitEnabled" (click)="submit(false)">
                            {{ 'form.submit.action.value'|translate }}
                        </button>

                        <!-- Enregistrer et continuer -->

                        <button class="btn_cta btn_little" type="button" [disabled]="!offerFormTabValidationService.isValid || !submitEnabled" (click)="submit(true)">
                            {{ 'form.submit.continue.action.value'|translate }}
                        </button>
                    }

                    @if(!form.get('onRequest').value) {

                        <!-- Enregistrer et renseigner les tarifs & disponibilités -->

                        <button class="btn_cta btn_little" type="button" [disabled]="!offerFormTabValidationService.isValid || !submitEnabled" (click)="submit(true, 'availabilities')">
                            {{ 'offer.submitAndSetAvailabilities.value' | translate }}
                        </button>
                    }
                }

                @if(!offerFormTabValidationService.currentItemIsLastItem) {

                    <!-- Passer à l'étape suivante -->

                    <button class="btn_cta btn_little" type="button" [disabled]="!offerFormTabValidationService.isCurrentItemValid" (click)="offerFormTabValidationService.goToNextItem()">
                        {{ 'form.tab.next.value' | translate }}
                    </button>
                }

            </div>
        </div>
    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group #tabGroup animationDuration="0ms">

        @for (tabItem of tabItems; track tabItem) {

            <mat-tab [disabled]="!offerFormTabValidationService.isSelectionItemAvailable(tabItem.tag)">
                <ng-template mat-tab-label>
                    <span>{{ tabItem.label | translate }}
                        @if(offerFormTabValidationService.hasTabDisplayedBadge(tabItem.tag)) {
                            <span class="tab_tag">{{ offerFormTabValidationService.getTabBadgeLabel(tabItem.tag) | translate }}</span>
                        }
                    </span>
                    <span [ngClass]="offerFormTabValidationService.getTabLabelClasses(tabItem.tag)"></span>
                </ng-template>
                <ng-container *ngTemplateOutlet="tabItem.template"></ng-container>
            </mat-tab>
        }

    </mat-tab-group>

</form>

<!-- Données générales -->

<ng-template #generalData>

    <ng-container [formGroup]="form">

        @if(society.offerConfiguration.allowOrchestra) {

            <div class="form_part">

                <p class="title_part">{{'orchestra.value' | translate}}</p>

                <!-- Offre Orchestra -->

                <ng-container formGroupName="configuration">

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'offer.orchestra.form.description.value' | translate}}</label>
                                <span style="font-style: italic">{{'offer.orchestra.form.help.value' | translate}}</span>
                                <div class="form-group" style="margin-top: 12px">
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="orchestra" class="form-control" id="orchestraNo">
                                        <label for="orchestraNo">{{'no.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="orchestra" class="form-control" id="orchestraYes">
                                        <label for="orchestraYes">{{'yes.value' | translate}}</label>
                                    </div>
                                </div>
                                @if(!isIndividualCustomerTypologyAvailable) {
                                    <div class="message">
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.orchestra.unavailable.description.value' | translate }}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </ng-container>

            </div>
        }

        <div class="form_part">

            <p class="title_part">{{'generalData.value' | translate}}</p>

            <div class="ligne_form row marges">
                <div class="col_6">
                    <!-- Référence -->
                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="reference" id="reference">
                        <label for="reference">{{ 'offer.form.fields.reference.value' | translate }}</label>
                    </div>
                </div>
                <div class="col_6">
                    <!-- Createur de l'offre -->
                    <div class="form-group">
                        <input type="text" value="" placeholder=" " class="form-control" formControlName="offerCreator" id="offer-creator" required="required">
                        <label for="offer-creator">{{ 'offer.form.fields.offerCreator.value' | translate }}</label>
                    </div>
                </div>
            </div>

            <!-- Type de clientèle -->
            <div class="ligne_form row marges">
                <div class="col_6">
                    <ng-container formGroupName="customerTypology">

                        <div class="form-group">
                            <select class="form-control" id="customerTypology" formControlName="id" required="required" (change)="handleCustomerTypologyType()">
                                <option value=""></option>
                                @for (customerTypology of customerTypologies; track customerTypology) {
                                    <option [value]="customerTypology.id">{{ translationService.getFallbackTranslation(customerTypology.translations).name }}</option>
                                }
                            </select>
                            <label class="required" for="customerTypology">{{ 'offer.form.fields.customerType.value' | translate }}</label>
                            <div class="message">
                                <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon>
                                    {{ 'offer.form.fields.customerType.description.value' | translate }}
                                </span>
                            </div>
                            @if(customerTypologyControl.get('id').invalid) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(customerTypologyControl.get('id').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="form_part">

            <p class="title_part">{{'offer.public.selection.value' | translate}}</p>

            <div class="row marges ligne_form">
                <div class="col_12">

                    <!-- Sélection du public de l'offre -->

                    <div class="form-group">

                        <div class="checkbox inline">
                            <input type="checkbox" id="offer-price-public-adult" [value]="'adult'" [checked]="isSelectedOfferPricePublic('adult')" (change)="handleOfferPricePublic($event)" [attr.disabled]="isOrchestra ? '' : null">
                            <label for="offer-price-public-adult">{{ 'offer.public.adult.value' | translate }}</label>
                        </div>

                        <div class="checkbox inline">
                            <input type="checkbox" id="offer-price-public-child" [value]="'child'" [checked]="isSelectedOfferPricePublic('child')" (change)="handleOfferPricePublic($event)">
                            <label for="offer-price-public-child">{{ 'offer.public.child.value' | translate }}</label>
                        </div>

                        @if(form.get('publics').invalid && (form.get('publics').dirty || form.get('publics').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('publics').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                    </div>
                </div>
            </div>

        </div>

        @if(isSelectedOfferPricePublic('child')) {

            <div class="form_part">

                <p class="title_part">{{'offer.childrenAge.title.value' | translate}}</p>

                <div class="row marges ligne_form">

                    <!-- Âge minimum enfant -->

                    <div class="col_md_6">
                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="minChildrenAge" id="minChildrenAge">
                            <label for="minChildrenAge">{{'offer.minChildrenAge.value' | translate}}</label>
                            @if(form.get('minChildrenAge').errors && (form.get('minChildrenAge').dirty || form.get('minChildrenAge').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('minChildrenAge').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(form.get('minChildrenAge').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                    <!-- Âge maximum enfant -->

                    <div class="col_md_6">
                        <div class="form-group">
                            <input type="text" value="" placeholder=" " class="form-control" formControlName="maxChildrenAge" id="maxChildrenAge">
                            <label for="maxChildrenAge">{{'offer.maxChildrenAge.value' | translate}}</label>
                            @if(form.get('maxChildrenAge').errors && (form.get('maxChildrenAge').dirty || form.get('maxChildrenAge').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('maxChildrenAge').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                        @if(form.get('maxChildrenAge').errors.pattern) {
                                            <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>

                </div>

            </div>
        }

        @if((form.get('customerTypology').valid || isOrchestra) && form.get('publics').valid) {

            <div class="form_part">

                <p class="title_part">{{'offer.presential.data.value' | translate}}</p>

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="ligne_form">
                            <div class="form-group">
                                @if(customerTypologyType === 'I') {
                                    <label>{{ 'offer.presential.individual.value' | translate }}</label>
                                }
                                @if(customerTypologyType === 'G') {
                                    <label>{{ 'offer.presential.group.value' | translate }}</label>
                                }
                            </div>
                        </div>
                        <div class="ligne_form">
                            <app-core-offer-presential-form [form]="form" [control]="presentialControl" [DOMIdentifier]="'offer-presential'" [enableMaxField]="customerTypologyType === 'I'" ></app-core-offer-presential-form>
                        </div>
                    </div>
                </div>
            </div>
        }

        <div class="form_part">

            <p class="title_part">{{'offer.publicationManagement.value' | translate}}</p>

            <div class="ligne_form row_marges">

                <div class="col_12">
                    <div class="form-group">
                        <select class="form-control" formControlName="published" id="published" required="required">
                            <option value=""></option>
                            @for ((pub of publishes$ | async); track pub) {
                                <option [value]="pub.name">{{ pub.label | translate }}</option>
                            }
                        </select>
                        <label class="required" for="published">{{ 'offer.form.fields.publication.value' | translate }}</label>
                        @if(form.get('published').invalid && (form.get('published').dirty || form.get('published').touched)) {
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(form.get('published').errors.required) {
                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                    }
                                </div>
                            </mat-error>
                        }
                        @if(!isPublishable) {
                            <span class="message-help error"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.publication.unavailable.description.value' | translate }}</span>
                        }
                    </div>
                </div>

            </div>

            <!-- Offre ciblée -->

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <div class="checkbox">
                            <input type="checkbox" id="isRestricted" formControlName="isRestricted">
                            <label for="isRestricted">{{ 'offer.targeted.value' | translate }}</label>
                        </div>
                    </div>
                </div>
            </div>

            @if(form.get('isRestricted').value) {

                <div class="row ligne_form">
                    <app-core-offer-restricted-society-collection-select [parentForm]="form" [formName]="'restrictedSocieties'" [society]="society"></app-core-offer-restricted-society-collection-select>
                </div>
            }

        </div>

        <ng-container formGroupName="duration">

            <div class="form_part">

                <p class="title_part">{{'offer.form.fields.duration.value' | translate}}</p>

                <!-- Durée -->
                <div class="ligne_form row marges">
                    <div class="col_6">
                        <div class="form-group">
                            <app-select-search [config]="fieldCollection.getFieldConfig('duration')" [form]="form" (valueChange)="changeDuration($event)"></app-select-search>
                            @if(groupDurationControl.invalid) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(groupDurationControl.controls.id.errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

            </div>

        </ng-container>

        @if((form.get('customerTypology').valid || isOrchestra)) {

            <div class="form_part">

                <p class="title_part">{{'offer.form.fields.locales.value' | translate}}</p>

                @if(!hasAccessAutomaticTranslation) {

                    <div class="ligne_form row marges">
                        <div class="col_12">
                            <div class="deletable_information">
                                <p [innerHTML]="'offer.form.fields.locales.noTranslationService.help.value' | translate"></p>
                            </div>
                        </div>
                    </div>
                }

                <!-- Langue -->

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <div class="form-group">
                            @for ((locale of locales$ | async); track locale) {
                                <div class="checkbox inline">
                                    <input type="checkbox" id="locale-{{locale.item.id}}" [value]="locale.item.id" [checked]="isSelectedLocale(locale.item)" [disabled]="!locale.enabled" (change)="handleLocaleSelection($event)">
                                    <label for="locale-{{locale.item.id}}">{{ locale.item.label | translate }}</label>
                                </div>
                            }
                            @if(form.get('locales').invalid && (form.get('locales').dirty || form.get('locales').touched)) {
                                <mat-error style="padding: 12px 0;">
                                    <div class="invalid-feedback">
                                        @if(form.get('locales').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <div class="form-group">
                            <div class="message">
                            <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon> {{ 'offer.form.fields.locale.description.value' | translate }}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Visuel commun ou propre à chaque langue -->

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'offer.translationPictureType.title.value' | translate}}</label>
                            <div class="form-group">
                                <div class="radio">
                                    <input type="radio" [value]="'common'" formControlName="translationPictureType" class="form-control" id="translationPictureTypeCommon">
                                    <label for="translationPictureTypeCommon">{{'no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="'dissociated'" formControlName="translationPictureType" class="form-control" id="translationPictureTypeDissociated">
                                    <label for="translationPictureTypeDissociated">{{'yes.value' | translate}}</label>
                                </div>
                                @if(form.get('translationPictureType').errors && (form.get('translationPictureType').dirty || form.get('translationPictureType').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('translationPictureType').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                @if(hasAccessAutomaticTranslation && form.get('locales').valid) {

                    <div #enableAutomaticTranslationReference class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'offer.translation.automatic.enable.question.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="false" [(ngModel)]="enableAutomaticTranslation" [ngModelOptions]="{standalone: true}" (ngModelChange)="handleEnableAutomaticTranslation()" class="form-control" id="enableAutomaticTranslationNo">
                                    <label for="enableAutomaticTranslationNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="true" [(ngModel)]="enableAutomaticTranslation" [ngModelOptions]="{standalone: true}" (ngModelChange)="handleEnableAutomaticTranslation()" class="form-control" id="enableAutomaticTranslationYes">
                                    <label for="enableAutomaticTranslationYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    @if(enableAutomaticTranslation) {

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{'offer.translation.automatic.locale.source.title.value' | translate}} : </label>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    @for ((sourceLocale of sourceLocales$ | async); track sourceLocale) {
                                        <div class="radio">
                                            <input type="radio" [value]="sourceLocale.item.id" [checked]="isSelectedSourceLocale(sourceLocale.item)" [disabled]="!sourceLocale.enabled" (change)="handleSourceLocaleSelection($event)" class="form-control" id="source-locale-{{ sourceLocale.item.id }}">
                                            <label for="source-locale-{{ sourceLocale.item.id }}">{{ sourceLocale.item.label | translate }}</label>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div #sourceLocaleDescriptionReference class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <div class="message">
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon> {{ 'offer.translation.automatic.locale.source.description.value' | translate }}
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if(!!automaticTranslationSourceLocale) {

                            <div class="row marges ligne_form">
                                <div class="col_12">
                                    <div class="form-group">
                                        <label>{{'offer.translation.automatic.locale.destination.title.value' | translate}} : </label>
                                    </div>
                                </div>
                            </div>

                            <div class="ligne_form row marges">
                                <div class="col_12">
                                    <div class="form-group">
                                        @for ((destinationLocale of destinationLocales$ | async); track destinationLocale) {
                                            <div class="checkbox inline">
                                                <input type="checkbox" id="destination-locale-{{destinationLocale.item.id}}" [value]="destinationLocale.item.id" [disabled]="!destinationLocale.enabled" [checked]="isSelectedDestinationLocale(destinationLocale.item)" (change)="handleDestinationLocaleSelection($event)">
                                                <label for="destination-locale-{{destinationLocale.item.id}}">{{ destinationLocale.item.label | translate }}</label>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div #destinationLocalesDescriptionReference class="row marges ligne_form">
                                <div class="col_12">
                                    <div class="form-group">
                                        <div class="message">
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon> {{ 'offer.translation.automatic.locale.destination.description.value' | translate }}
                                    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        @if(automaticTranslationSourceLocale && automaticTranslationDestinationLocales.length) {

                            <div #translationRequestSummaryReference class="row ligne_form">

                                @if(card) {

                                    @if(translationRequestSummary$.getValue().totalPriceTTC) {

                                        <div class="ligne_form create_card_information col_12">
                                            <p [innerHTML]="'offer.translation.automatic.price.description.value' | translate:{ count: automaticTranslationDestinationLocales.length, price: (translationRequestSummary$.getValue().totalPriceTTC / 100) | parsePrice, card: (card.cardNumber + ' | ' + (card.expirationDate | slice:0:2) + '/' + (card.expirationDate | slice:2:4) ) }"></p>
                                        </div>

                                        <!-- Je souhaite traduire automatiquement mon offre et valide le montant facturé. -->

                                        <div class="row marges ligne_form">
                                            <div class="col_12">
                                                <div class="form-group">
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="optinAutomaticTranslation" formControlName="optinAutomaticTranslation">
                                                        <label for="optinAutomaticTranslation">{{ 'offer.optinAutomaticTranslation.description.value' | translate }}</label>
                                                        @if(form.get('optinAutomaticTranslation').errors && (form.get('optinAutomaticTranslation').dirty || form.get('optinAutomaticTranslation').touched)) {
                                                            <mat-error>
                                                                <div class="invalid-feedback">
                                                                    @if(form.get('optinAutomaticTranslation').errors.isRequired) {
                                                                        <div>{{ 'offer.optinAutomaticTranslation.required.value' | translate }}</div>
                                                                    }
                                                                </div>
                                                            </mat-error>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                } @else {

                                    <div class="ligne_form create_card_information failed col_12">
                                        <p [innerHTML]="'offer.translation.automatic.price.noCard.value' | translate"></p>
                                    </div>
                                }

                            </div>
                        }
                    }
                }
            </div>
        }

    </ng-container>

</ng-template>

<!-- Gestion de contenu -->

<ng-template #contentManagement>

    <ng-container [formGroup]="form">

        <div class="content_tab">

            <!-- Nom de l’offre-->

            @if(translationBuilder.items.length) {

                <div class="form_part">

                    <p class="title_part">{{ 'offer.form.fields.offerName.value' | translate }}</p>

                    <div class="ligne_form row marges">
                        <div class="col_12">
                            <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['name']">

                                <ng-container formArrayName="translations">

                                    <mat-tab-group [@.disabled]="true">
                                        @for (locale of offerService.displayedLocales$.getValue(); track locale) {

                                            <div>
                                                <mat-tab label="{{translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['name']">
                                                    <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                        <div class="row marges ligne_form">
                                                            <div class="col_12">


                                                                <div class="form-group">
                                                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="name"
                                                                           id="name" required="required" appInputCapitalize>
                                                                    <label for="name">{{ 'offer.form.fields.offerName.value' | translate }}</label>
                                                                    @if(translationBuilder.getItemControlByLocale(locale).get('name').errors && (translationBuilder.getItemControlByLocale(locale).get('name').dirty || translationBuilder.getItemControlByLocale(locale).get('name').touched)) {
                                                                        <mat-error>
                                                                            <div class="invalid-feedback">
                                                                                @if(translationBuilder.getItemControlByLocale(locale).get('name').errors.required) {
                                                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                }
                                                                                @if(translationBuilder.getItemControlByLocale(locale).get('name').errors.pattern) {
                                                                                    <div>{{ 'offer.form.control.name.error.pattern.value' | translate }}</div>
                                                                                }
                                                                            </div>
                                                                        </mat-error>
                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </mat-tab>
                                            </div>
                                        }
                                    </mat-tab-group>

                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            }

            @if(translationBuilder.items.length) {

                <div class="form_part">

                    <p class="title_part">{{ 'offer.form.fields.teaser.value' | translate }}</p>

                    <!-- Accroche -->

                    <div class="ligne_form row marges">
                        <div class="col_12">
                            <div class="form-group">
                                <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['teaser']">

                                    <ng-container formArrayName="translations">

                                        <mat-tab-group [@.disabled]="true">
                                            @for (locale of offerService.displayedLocales$.getValue(); track locale) {

                                                <div>
                                                    <mat-tab label="{{translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['teaser']">
                                                        <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                            <div class="row marges ligne_form">
                                                                <div class="col_12">
                                                                    <div class="form-group">
                                                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="teaser" id="teaser-{{translationBuilder.getItemIndexByLocale(locale)}}"
                                                                               [limit]="150" [formControlReference]="translationBuilder.getItemControlByLocale(locale).get('teaser')" [placeholderElement]="formControlTeaser" appInputCountLimit
                                                                               appInputTextStripTags>
                                                                        <label for="teaser-{{translationBuilder.getItemIndexByLocale(locale)}}">{{ 'offer.form.fields.teaser.value' | translate }}</label>
                                                                        <div class="message">
                                                                            <span>
                                                                                <span #formControlTeaser class="form-control-input"></span> {{ 'form.input.type' | translate }}
                                                                            </span>
                                                                        </div>
                                                                        @if(translationBuilder.getItemControlByLocale(locale).get('teaser').errors && (translationBuilder.getItemControlByLocale(locale).get('teaser').dirty || translationBuilder.getItemControlByLocale(locale).get('teaser').touched)) {
                                                                            <mat-error>
                                                                                <div class="invalid-feedback">
                                                                                    @if(translationBuilder.getItemControlByLocale(locale).get('teaser').errors.pattern) {
                                                                                        <div>{{ 'form.control.error.maxLength.value' | translate: { maxLength: 150 } }}</div>
                                                                                    }
                                                                                </div>
                                                                            </mat-error>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </mat-tab>
                                                </div>
                                            }
                                        </mat-tab-group>
                                    </ng-container>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            }

            <div class="form_part" [style.display]="translationBuilder.items.length < 1 ? 'none': 'block'">

                <p class="title_part">{{ 'offer.form.fields.interests.title.value' | translate }} ({{ 'offer.form.fields.interests.max.value' | translate }})</p>

                <!-- Intérêts -->

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <app-offer-interest-create [parentInterests]="form" [offer]="null" (controlUpdated)="handleContentManagementValidators()"></app-offer-interest-create>
                    </div>
                </div>

            </div>

            @if(translationBuilder.items.length) {

                <div class="form_part">

                    <p class="title_part">{{ 'offer.location.description.value' | translate }}</p>

                    <!-- Description -->

                    <div class="ligne_form row marges">
                        <div class="col_12">
                            <div class="ligne_form row marges">
                                <div class="col_12">
                                    <div class="form-group">
                                        <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['description']">

                                            <ng-container formArrayName="translations">

                                                <!-- Description -->
                                                <mat-tab-group [@.disabled]="true">
                                                    @for (locale of offerService.displayedLocales$.getValue(); track locale) {

                                                        <div>
                                                            <mat-tab label="{{translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['description']">
                                                                <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                                    <div class="row marges ligne_form">
                                                                        <div class="col_12">
                                                                            <div class="form-group">
                                                                                <label>{{ 'offer.location.description.value' | translate }}</label>
                                                                                <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="descriptionEditorConfig"></app-ckeditor>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </ng-container>
                                                            </mat-tab>
                                                        </div>
                                                    }
                                                </mat-tab-group>
                                            </ng-container>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            }

            <div class="form_part" [style.display]="translationBuilder.items.length < 1 ? 'none': 'block'">

                <p class="title_part">{{ 'offer.form.fields.included.value' | translate }}</p>

                <!-- Compris dans l'offre -->

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <app-offer-included-create [parentIncluds]="form" [offer]="null" (controlUpdated)="handleContentManagementValidators()"></app-offer-included-create>
                    </div>
                </div>

            </div>

            <div class="form_part" [style.display]="translationBuilder.items.length < 1 ? 'none': 'block'">

                <p class="title_part">{{ 'offer.form.fields.included.no.value' | translate }}</p>

                <!-- Non compris dans l'offre -->

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <app-offer-no-included-create [parentIncluds]="form" [offer]="null" (controlUpdated)="handleContentManagementValidators()"></app-offer-no-included-create>
                    </div>
                </div>
            </div>

            @if(translationBuilder.items.length && groupDurationControl.valid && (getOfferDurationById(groupDurationControl.value.id).value > 1)) {

                <div class="form_part" [style.display]="translationBuilder.items.length < 1 ? 'none': 'block'">

                    <p class="title_part">{{ 'offer.form.fields.accommodation.value' | translate }}</p>

                    <!-- Hébergements -->

                    <div class="ligne_form row marges">
                        <div class="col_12">
                            <div class="ligne_form row marges">
                                <div class="col_12">
                                    <div class="form-group">
                                        <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['accommodation']">

                                            <ng-container formArrayName="translations">

                                                <!-- Description de l'hébergement -->
                                                <mat-tab-group [@.disabled]="true">
                                                    @for (locale of offerService.displayedLocales$.getValue(); track locale) {

                                                        <div>
                                                            <mat-tab label="{{translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['accommodation']">
                                                                <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                                    <div class="row marges ligne_form">
                                                                        <div class="col_12">
                                                                            <div class="form-group">
                                                                                <label>{{ 'offer.location.description.value' | translate }}</label>
                                                                                <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="accommodationEditorConfig"></app-ckeditor>
                                                                                <div class="form-group col_content y_items_center">
                                                                                    <div class="message">
                                                                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.translation.accommodation.info.value' | translate }}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </ng-container>
                                                            </mat-tab>
                                                        </div>
                                                    }
                                                </mat-tab-group>
                                            </ng-container>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            }

            @if(translationBuilder.items.length) {

                <div class="form_part">

                    <p class="title_part">
                        {{ 'offer.form.fields.pictures.value' | translate }}
                        <span>{{ 'offer.form.fields.pictures.infos.value' | translate}}</span>
                        <span class="alert">{{ 'offer.form.fields.pictures.min.value' | translate}}</span>
                    </p>

                    @if(isTranslationPictureType('dissociated')) {

                        <div class="ligne_form row marges">
                            <div class="col_12">
                                <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['pictures']">

                                    <ng-container formArrayName="translations">

                                        <!-- Visuels -->

                                        <mat-tab-group [@.disabled]="true">

                                            @for (locale of offerService.displayedLocales$.getValue(); track locale) {

                                                <div>
                                                    <mat-tab label="{{translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['pictures']">
                                                        <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                            <div formArrayName="pictures" class="add_picture collection">
                                                                <div class="row marges">

                                                                    @for (picture of getSortedPictureControls(translationBuilder.getItemControlByLocale(locale)); track picture; let j = $index) {
                                                                        <div class="col_4">
                                                                            <div class="removable_item">
                                                                                <ng-container [formGroupName]="j">
                                                                                    <div class="ligne_form row marges">
                                                                                        <div class="col_content">
                                                                                            <div class="form-group">
                                                                                                <form-field-image [config]="picturesConfig" [form]="picture.get('image')" (imageAdded)="translationPictureCopyright.readOnly = false" (imageDeleted)="translationPictureCopyright.readOnly = true"></form-field-image>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="ligne_form row marges">
                                                                                        <div class="col_12">
                                                                                            <div class="form-group">
                                                                                                <input #translationPictureCopyright type="text" value="" placeholder=" " class="form-control" formControlName="copyright" id="copyright_{{j}}" required="required" [readOnly]="true">
                                                                                                <label for="copyright_{{j}}">{{ 'offer.form.fields.copyright.value' | translate }}</label>
                                                                                                @if(translationBuilder.getItemControlByLocale(locale).get('pictures')['controls'][j].get('copyright').errors && (translationBuilder.getItemControlByLocale(locale).get('pictures')['controls'][j].get('copyright').dirty || translationBuilder.getItemControlByLocale(locale).get('pictures')['controls'][j].get('copyright').touched)) {
                                                                                                    <mat-error>
                                                                                                        <div class="invalid-feedback">
                                                                                                            @if(translationBuilder.getItemControlByLocale(locale).get('pictures')['controls'][j].get('copyright').errors.required) {
                                                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </mat-error>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    @if(translationBuilder.getItemControlByLocale(locale).get('pictures').controls.length > 1) {
                                                                                        <button type="button" class="btn_cta btn_lines btn_small move_item up" [disabled]="!isDecreaseTranslationPicturePositionAllowed(translationBuilder.getItemControlByLocale(locale).get('pictures'), j)" (click)="decreaseTranslationPicturePosition(translationBuilder.getItemControlByLocale(locale).get('pictures'), j)">
                                                                                            <mat-icon>arrow_back</mat-icon>
                                                                                        </button>
                                                                                        <button type="button" class="btn_cta btn_lines btn_small move_item down" [disabled]="!isIncreaseTranslationPicturePositionAllowed(translationBuilder.getItemControlByLocale(locale).get('pictures'), j)" (click)="increaseTranslationPicturePosition(translationBuilder.getItemControlByLocale(locale).get('pictures'), j)">
                                                                                            <mat-icon>arrow_forward</mat-icon>
                                                                                        </button>
                                                                                    }
                                                                                    <button type="button" class="btn_cta btn_red btn_small remove_item" (click)="removeTranslationPicture(translationBuilder.getItemControlByLocale(locale).get('pictures'), j)">
                                                                                        <mat-icon>delete</mat-icon>
                                                                                    </button>
                                                                                </ng-container>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div class="ligne_form">
                                                                    <button class="btn_cta btn_little" type="button" (click)="addTranslationPicture(translationBuilder.getItemControlByLocale(locale).get('pictures'))">{{ 'offer.form.fields.picture.value' | translate }}</button>
                                                                </div>
                                                            </div>

                                                        </ng-container>
                                                    </mat-tab>
                                                </div>
                                            }
                                        </mat-tab-group>
                                    </ng-container>

                                </div>
                            </div>
                        </div>

                    }

                    @if(isTranslationPictureType('common')) {

                        <div class="ligne_form row marges">
                            <div class="col_12">
                                <ng-container formArrayName="translations">

                                    <ng-container [formGroupName]="0">

                                        <div formArrayName="pictures" class="add_picture collection">
                                            <div class="row marges">
                                                @for (picture of getSortedPictureControls(translationBuilder.itemsControl.at(0)); track picture; let j = $index) {
                                                    <div class="col_4">
                                                        <div class="removable_item">
                                                            <ng-container [formGroupName]="j">
                                                                <div class="ligne_form row marges">
                                                                    <div class="col_content">
                                                                        <div class="form-group">
                                                                            <form-field-image [config]="picturesConfig" [form]="picture.get('image')" (imageAdded)="translationPictureCopyright.readOnly = false" (imageDeleted)="translationPictureCopyright.readOnly = true"></form-field-image>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="ligne_form row marges">
                                                                    <div class="col_12">
                                                                        <div class="form-group">
                                                                            <input #translationPictureCopyright type="text" value="" placeholder=" " class="form-control" formControlName="copyright" id="copyright_{{j}}" required="required" [readOnly]="true">
                                                                            <label for="copyright_{{j}}">{{ 'offer.form.fields.copyright.value' | translate }}</label>
                                                                            @if(translationBuilder.itemsControl.at(0).get('pictures')['controls'][j].get('copyright').errors && (translationBuilder.itemsControl.at(0).get('pictures')['controls'][j].get('copyright').dirty || translationBuilder.itemsControl.at(0).get('pictures')['controls'][j].get('copyright').touched)) {
                                                                                <mat-error>
                                                                                    <div class="invalid-feedback">
                                                                                        @if(translationBuilder.itemsControl.at(0).get('pictures')['controls'][j].get('copyright').errors.required) {
                                                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                                        }
                                                                                    </div>
                                                                                </mat-error>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                @if(translationBuilder.itemsControl.at(0).get('pictures').controls.length > 1) {
                                                                    <button type="button" class="btn_cta btn_lines btn_small move_item up" [disabled]="!isDecreasePicturePositionAllowed(j)" (click)="decreasePicturePosition(j)">
                                                                        <mat-icon>arrow_back</mat-icon>
                                                                    </button>
                                                                    <button type="button" class="btn_cta btn_lines btn_small move_item down" [disabled]="!isIncreasePicturePositionAllowed(j)" (click)="increasePicturePosition(j)">
                                                                        <mat-icon>arrow_forward</mat-icon>
                                                                    </button>
                                                                }
                                                                <button type="button" class="btn_cta btn_red btn_small remove_item" (click)="removePicture(j)">
                                                                    <mat-icon>delete</mat-icon>
                                                                </button>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ng-container>

                                </ng-container>
                            </div>
                        </div>

                        <div class="row ligne_form">
                            <button class="btn_cta btn_little" type="button" (click)="addPicture()">{{ 'offer.form.fields.picture.value' | translate }}</button>
                        </div>
                    }

                </div>
            }

        </div>

    </ng-container>

</ng-template>

<!-- Données programme -->

<ng-template #programData>

    <ng-container [formGroup]="form">

        <div class="ligne_form row marges">
            <div class="col_12">

                <!-- Ajout des photos au programmes -->

                <div class="form-group">
                    <div class="checkbox inline">
                        <input type="checkbox" formControlName="hasProgramsPictures" id="offer-program-pictures"  [checked]="form.get('hasProgramsPictures').value">
                        <label for="offer-program-pictures">{{ 'offer.program.pictures.value' | translate }}</label>
                    </div>
                </div>
            </div>
        </div>

        @if(!!groupDurationControl.get('id').value) {
            <div class="ligne_form">
                <app-core-offer-programs-form [parentForm]="form" [formArray]="programsControl" [limitProgram]="limitProgram" [offer]="null" (controlUpdated)="handleContentManagementValidators()"></app-core-offer-programs-form>
            </div>
        }

    </ng-container>

</ng-template>

<!-- Données prestataires -->

<ng-template #providerData>

    <ng-container [formGroup]="form">

        <div class="ligne_form">
            <app-offer-provider-create [parentProviderSocieties]="form" [formName]="'providerSocieties'" [offer]="null" [society]="society"></app-offer-provider-create>
        </div>

    </ng-container>

</ng-template>

<!-- Données caractéristiques -->

<ng-template #characteristicData>

    <ng-container [formGroup]="form">

        <div class="form-group">
            <app-core-offer-attributes-form [attributesFormReference]="attributesFormReference" [parentFormSubmitSubscription]="formSubmitSubscription" [formArray]="attributesControl"></app-core-offer-attributes-form>
        </div>

    </ng-container>

</ng-template>

<!-- Données localisation -->

<ng-template #locationData>

    <ng-container [formGroup]="form">

        <div class="content_tab">

            <div class="collection" cdkDropList (cdkDropListDropped)="dragDropService.dragAndDrop(locationsControl, $event)">

                <!-- Type de localisation -->

                <div class="form_part">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'offer.location.type.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="false"  formControlName="enableMultipleMainLocation" class="form-control" id="multipleLocationsNo">
                                <label for="multipleLocationsNo">{{'offer.location.default.value' | translate}}</label>
                            </div>
                            @if(geolocationIsAllowed) {
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="enableMultipleMainLocation" class="form-control" id="multipleLocationsYes">
                                    <label for="multipleLocationsYes">{{'offer.location.multiple.value' | translate}}</label>
                                </div>
                            }
                            @if(form.get('enableMultipleMainLocation').errors && (form.get('enableMultipleMainLocation').dirty || form.get('enableMultipleMainLocation').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('enableMultipleMainLocation').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <!-- Circuit itinérant ou en étoile -->

                @if(!form.get('enableMultipleMainLocation').value && (locationsControl.controls.length > 1)) {

                    <div class="form_part">

                        <div class="ligne_form">

                            <div class="form-group">
                                <label>{{'offer.locations.type.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="'star'" formControlName="circuitType" class="form-control" id="circuitTypeStar">
                                    <label for="circuitTypeStar">{{'offer.locations.type.star.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="'itinerant'" formControlName="circuitType" class="form-control" id="circuitTypeItinerant">
                                    <label for="circuitTypeItinerant">{{'offer.locations.type.itinerant.value' | translate}}</label>
                                </div>
                                @if(form.get('circuitType').errors && (form.get('circuitType').dirty || form.get('circuitType').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('circuitType').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>

                        </div>

                    </div>
                }

                <!-- Plusieurs adresses principales -->

                @if(form.get('enableMultipleMainLocation').value) {

                    <!-- Localisations de votre offre -->

                    <div class="form_part">

                        <p class="title_part">{{ 'offer.location.main.value' | translate }}
                            <span>
                             {{ 'offer.location.multiple.description.value' | translate }}
                            </span>
                        </p>

                        <!-- Associations des prestaires à chaque localisation -->

                        @if(locationsControl.controls.length > 0) {
                            <div class="row marges mb_24">

                                <div class="col_12">
                                    <div class="form-group">
                                        <label>{{'offer.location.providers.value' | translate}}</label>
                                        <app-offer-location-provider  [form]="form"  [hideSelection]="true" [providersForm]="form" [formName]="'providerLocations'" [emitProviderLocationsUpdate]="true"></app-offer-location-provider>

                                    </div>
                                </div>

                            </div>
                        }

                        <mat-accordion >

                            @for (_ of locationsControl.controls; track _; let i = $index) {

                                <div class="location ligne_form" [ngClass]="( locationsControl.controls.length > 1 ? 'removable_item' : '')">

                                    <app-core-offer-location-form cdkDrag [form]="form" [formArrayName]="'locations'" [index]="i" [translationBuilder]="getLocationTranslationBuilder(i)" [accessMultipleGeolocation]="hasAccessMultipleGeolocation"></app-core-offer-location-form>

                                    <!-- Suppression de la localisation -->

                                    @if(locationsControl.controls.length > 1) {

                                        <button type="button" class="btn_cta btn_red btn_little remove_item" (click)="removeLocation(i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>

                                    }

                                </div>
                            }

                        </mat-accordion>

                    </div>
                }

                <!-- 1 adresse principale et plusieurs adresses secondaires -->

                @if(!form.get('enableMultipleMainLocation').value) {

                    <!-- Localisation principale -->

                    <div class="form_part">

                        <p class="title_part">{{ 'offer.location.main.value' | translate }}
                            <span>
                            {{ 'offer.location.info.value' | translate }}
                        </span>
                        </p>

                        <mat-accordion>
                            <div class="location ligne_form">
                                <app-core-offer-location-form  cdkDrag [form]="form" [formArrayName]="'locations'" [index]="0" [translationBuilder]="getLocationTranslationBuilder(0)" [usedForTransportAccess]="locationControlUsedForTransportAccess(locationsControl.controls.at(0))"></app-core-offer-location-form>
                            </div>
                        </mat-accordion>

                    </div>

                    <!-- Localisations secondaires -->

                    @if(locationsControl.controls.length > 1) {

                        <div class="form_part">

                            <p class="title_part">{{ 'offer.location.secondary.plural.value' | translate }}</p>

                            <mat-accordion>

                                @for (_ of locationsControl.controls; track _; let i = $index) {

                                    @if(i > 0) {
                                        <div class="location ligne_form removable_item">

                                            <app-core-offer-location-form cdkDrag [form]="form" [formArrayName]="'locations'" [index]="i" [translationBuilder]="getLocationTranslationBuilder(i)" [usedForTransportAccess]="locationControlUsedForTransportAccess(locationsControl.controls.at(i))"></app-core-offer-location-form>

                                            <!-- Suppression de la localisation -->

                                            <button type="button" class="btn_cta btn_red btn_little remove_item" (click)="removeLocation(i)">
                                                <mat-icon>delete</mat-icon>
                                            </button>

                                        </div>
                                    }
                                }

                            </mat-accordion>

                        </div>
                    }
                }

                <div class="form_part">

                    <!-- Ajout d'une localisation -->
                    <div class="ligne_form">
                        <button class="btn_cta btn_little" type="button" [disabled]="form.get('locations').value.length >= limitLocation && !form.get('enableMultipleMainLocation').value " (click)="addLocation()">{{ 'offer.location.add.action.value' | translate }}</button>
                    </div>

                    <!-- Affichage des erreurs -->


                    @if(locationsControl.errors) {
                        <div class="ligne_form">
                            <mat-error>
                                <div class="invalid-feedback">
                                    @if(locationsControl.errors.maxlength) {
                                        <div>{{ (form.get('limitLocation').value > 0 ? 'offer.location.secondary.control.error.maxLength.plural.value' : 'offer.location.secondary.control.error.maxLength.value') | translate:{max: limitLocation - 1} }}</div>
                                    }
                                </div>
                            </mat-error>
                        </div>
                    }

                </div>

            </div>

        </div>
    </ng-container>

</ng-template>

<!-- Accès -->

<ng-template #access>

    <ng-container [formGroup]="form">

        <div class="form_part">

            <div class="offer_multiple_translations added_bottom_margin">
                <p [innerHTML]="'offer.access.description.value'|translate"></p>
            </div>

        </div>

        <div class="form_part">

            <div class="row marges ligne_form">
                <div class="col_12">
                    <div class="form-group">
                        <label>{{'offer.access.transport.type.plural.label.value' | translate}}</label>
                        <div class="checkbox inline">
                            <input type="checkbox" id="accessTransportTrainStation" [value]="'train-station'" [checked]="isSelectedTransportType('train-station')" (change)="handleTransportConfiguration($event)">
                            <label for="accessTransportTrainStation">{{ 'transport.trainStation.value' | translate }}</label>
                        </div>
                        <div class="checkbox inline">
                            <input type="checkbox" id="accessTransportAirport" [value]="'airport'" [checked]="isSelectedTransportType('airport')" (change)="handleTransportConfiguration($event)">
                            <label for="accessTransportAirport">{{ 'transport.airport.value' | translate }}</label>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        @if(selectedAccessTransportTypes.length) {

            <!-- Accès début de programme -->

            <div class="form_part limited">

                <div class="title_part gradient form_panel" [ngClass]="{ 'open': isOpenPanel('accessProgramStart'), 'closed': !isOpenPanel('accessProgramStart') }" (click)="togglePanelOpening('accessProgramStart')">
                    <div [ngClass]="{ 'valid': isValidPanel('accessProgramStart'), 'invalid': !isValidPanel('accessProgramStart') }"></div>
                    {{ 'offer.access.program.start.title.value' | translate }}
                </div>

                @if(isOpenPanel('accessProgramStart')) {

                    <!-- Choix de la localisation -->

                    <div class="ligne_form row marges">
                        <div class="col_6">
                            <div class="form-group">
                                <mat-select [compareWith]="compareByFormGroupPosition" [(ngModel)]="arrivalOfferLocationControl" [ngModelOptions]="{standalone: true}" (selectionChange)="handleOfferLocationTransportConfiguration($event.value, OfferLocationDirection.Arrival)">
                                    @for (locationControl of locationsControl.controls; track locationControl) {
                                        <mat-option [value]="locationControl">
                                            {{ locationControl.value.address }}, {{ locationControl.value.zipcode }} {{ locationControl.value.city }}
                                        </mat-option>
                                    }
                                </mat-select>
                                <mat-label>{{ 'offer.access.location.choice.placeholder.value' | translate }}</mat-label>
                                @if(transportOfferLocationsControl.get('arrival').errors) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(transportOfferLocationsControl.get('arrival').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    @if(arrivalOfferLocationControl && transportDisplayedConfiguration[OfferLocationDirection.Arrival]) {

                        <div class="ligne_form row marges">

                            <!-- Gare conseillée -->

                            @if(isSelectedTransportType('train-station')) {

                                <div class="col_6">
                                    <app-core-offer-location-transport-select-search [offerLocationControl]="arrivalOfferLocationControl" [direction]="OfferLocationDirection.Arrival" [type]="'train-station'"></app-core-offer-location-transport-select-search>
                                </div>
                            }

                            <!-- Aéroport conseillé -->

                            @if(isSelectedTransportType('airport')) {

                                <div class="col_6">
                                    <app-core-offer-location-transport-select-search [offerLocationControl]="arrivalOfferLocationControl" [direction]="OfferLocationDirection.Arrival" [type]="'airport'"></app-core-offer-location-transport-select-search>
                                </div>
                            }

                        </div>

                        @if(isSelectedTransportType('train-station') || isSelectedTransportType('airport')) {

                            <!-- Informations complémentaires -->

                            <div class="ligne_form row marges">
                                <div class="col_12">
                                    <div class="form-group">
                                        <label>{{ 'offer.access.program.additionalInformation.title.value' | translate }}</label>
                                    </div>
                                </div>
                            </div>

                            <div class="ligne_form row marges">

                                @if(isSelectedTransportType('train-station')) {

                                    <div class="col_6">
                                        <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['transportArrivalTrainStationDescription']">

                                            <ng-container formArrayName="translations">

                                                <mat-tab-group [@.disabled]="true">
                                                    @for (locale of offerService.displayedLocales$.getValue(); track locale) {
                                                        <div>
                                                            <mat-tab label="{{ translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['transportArrivalTrainStationDescription']">
                                                                <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                                    <div class="row marges ligne_form">
                                                                        <div class="col_12">
                                                                            <div class="form-group">
                                                                                <label>
                                                                                    <img [src]="'assets/images/icons/transport/train-station.svg'" [alt]="'train-station'"/>
                                                                                    {{ 'offer.form.fields.transport.trainStation.description.value' | translate }}
                                                                                </label>
                                                                                <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="transportArrivalTrainStationDescriptionEditorConfig"></app-ckeditor>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </ng-container>
                                                            </mat-tab>
                                                        </div>
                                                    }
                                                </mat-tab-group>

                                            </ng-container>

                                        </div>
                                    </div>
                                }

                                @if(isSelectedTransportType('airport')) {

                                    <div class="col_6">
                                        <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['transportArrivalAirportDescription']">

                                            <ng-container formArrayName="translations">

                                                <mat-tab-group [@.disabled]="true">
                                                    @for (locale of offerService.displayedLocales$.getValue(); track locale) {
                                                        <div>
                                                            <mat-tab label="{{ translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['transportArrivalAirportDescription']">
                                                                <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                                    <div class="row marges ligne_form">
                                                                        <div class="col_12">
                                                                            <div class="form-group">
                                                                                <label>
                                                                                    <img [src]="'assets/images/icons/transport/airport.svg'" [alt]="'airport'"/>
                                                                                    {{ 'offer.form.fields.transport.airport.description.value' | translate }}
                                                                                </label>
                                                                                <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="transportArrivalAirportDescriptionEditorConfig"></app-ckeditor>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </ng-container>
                                                            </mat-tab>
                                                        </div>
                                                    }
                                                </mat-tab-group>

                                            </ng-container>

                                        </div>
                                    </div>
                                }

                            </div>
                        }
                    }
                }

            </div>

            <!-- Accès fin de programme -->

            <div class="form_part limited">

                <div class="title_part gradient form_panel" [ngClass]="{ 'open': isOpenPanel('accessProgramEnd'), 'closed': !isOpenPanel('accessProgramEnd') }" (click)="togglePanelOpening('accessProgramEnd')">
                    <div [ngClass]="{ 'valid': isValidPanel('accessProgramEnd'), 'invalid': !isValidPanel('accessProgramEnd') }"></div>
                    {{ 'offer.access.program.end.title.value' | translate }}
                </div>

                @if(isOpenPanel('accessProgramEnd')) {

                    <!-- Localisation de fin identique à la localisation de début -->

                    <div class="ligne_form row marges">

                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'offer.access.program.end.sameAsStart.title.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="startLocationSameAsEndLocation" class="form-control" id="startLocationSameAsEndLocationYes" (change)="handleDepartureOfferLocation(true)">
                                    <label for="startLocationSameAsEndLocationYes">{{'yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="startLocationSameAsEndLocation" class="form-control" id="startLocationSameAsEndLocationNo" (change)="handleDepartureOfferLocation(false)">
                                    <label for="startLocationSameAsEndLocationNo">{{'no.value' | translate}}</label>
                                </div>
                            </div>
                        </div>

                    </div>

                    @if(!form.get('startLocationSameAsEndLocation').value) {

                        <!-- Choix de la localisation -->

                        <div class="ligne_form row marges">
                            <div class="col_6">
                                <div class="form-group">
                                    <mat-select [compareWith]="compareByFormGroupPosition" [(ngModel)]="departureOfferLocationControl" [ngModelOptions]="{standalone: true}" (selectionChange)="handleOfferLocationTransportConfiguration($event.value, OfferLocationDirection.Departure)">
                                        @for (locationControl of locationsControl.controls; track locationControl) {
                                            <mat-option [value]="locationControl">
                                                {{ locationControl.value.address }}, {{ locationControl.value.zipcode }} {{ locationControl.value.city }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                    <mat-label>{{ 'offer.access.location.choice.placeholder.value' | translate }}</mat-label>
                                    @if(transportOfferLocationsControl.get('departure').errors) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(transportOfferLocationsControl.get('departure').errors.isRequired) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>
                        </div>

                        @if(departureOfferLocationControl && transportDisplayedConfiguration[OfferLocationDirection.Departure]) {

                            <div class="ligne_form row marges">

                                <!-- Gare conseillée -->

                                @if(isSelectedTransportType('train-station')) {

                                    <div class="col_6">
                                        <app-core-offer-location-transport-select-search [offerLocationControl]="departureOfferLocationControl" [direction]="OfferLocationDirection.Departure" [type]="'train-station'"></app-core-offer-location-transport-select-search>
                                    </div>
                                }

                                <!-- Aéroport conseillé -->

                                @if(isSelectedTransportType('airport')) {

                                    <div class="col_6">
                                        <app-core-offer-location-transport-select-search [offerLocationControl]="departureOfferLocationControl" [direction]="OfferLocationDirection.Departure" [type]="'airport'"></app-core-offer-location-transport-select-search>
                                    </div>
                                }

                            </div>

                            @if(isSelectedTransportType('train-station') || isSelectedTransportType('airport')) {

                                <div class="ligne_form row marges">
                                    <div class="col_12">
                                        <div class="form-group">
                                            <label>{{ 'offer.access.program.additionalInformation.title.value' | translate }}</label>
                                        </div>
                                    </div>
                                </div>

                                <!-- Informations complémentaires -->

                                <div class="ligne_form row marges">

                                    @if(isSelectedTransportType('train-station')) {

                                        <div class="col_6">
                                            <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['transportDepartureTrainStationDescription']">

                                                <ng-container formArrayName="translations">

                                                    <mat-tab-group [@.disabled]="true">
                                                        @for (locale of offerService.displayedLocales$.getValue(); track locale) {
                                                            <div>
                                                                <mat-tab label="{{ translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['transportDepartureTrainStationDescription']">
                                                                    <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                                        <div class="row marges ligne_form">
                                                                            <div class="col_12">
                                                                                <div class="form-group">
                                                                                    <label>
                                                                                        <img [src]="'assets/images/icons/transport/train-station.svg'" [alt]="'train-station'"/>
                                                                                        {{ 'offer.form.fields.transport.trainStation.description.value' | translate }}
                                                                                    </label>
                                                                                    <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="transportDepartureTrainStationDescriptionEditorConfig"></app-ckeditor>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ng-container>
                                                                </mat-tab>
                                                            </div>
                                                        }
                                                    </mat-tab-group>

                                                </ng-container>

                                            </div>
                                        </div>
                                    }

                                    @if(isSelectedTransportType('airport')) {

                                        <div class="col_6">
                                            <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['transportDepartureAirportDescription']">

                                                <ng-container formArrayName="translations">

                                                    <mat-tab-group [@.disabled]="true">
                                                        @for (locale of offerService.displayedLocales$.getValue(); track locale) {
                                                            <div>
                                                                <mat-tab label="{{ translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['transportDepartureAirportDescription']">
                                                                    <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                                        <div class="row marges ligne_form">
                                                                            <div class="col_12">
                                                                                <div class="form-group">
                                                                                    <label>
                                                                                        <img [src]="'assets/images/icons/transport/airport.svg'" [alt]="'airport'"/>
                                                                                        {{ 'offer.form.fields.transport.airport.description.value' | translate }}
                                                                                    </label>
                                                                                    <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="transportDepartureAirportDescriptionEditorConfig"></app-ckeditor>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ng-container>
                                                                </mat-tab>
                                                            </div>
                                                        }
                                                    </mat-tab-group>

                                                </ng-container>

                                            </div>
                                        </div>
                                    }

                                </div>
                            }
                        }
                    }
                }

            </div>
        }

        <!-- Options d'affichage -->

        <div class="form_part limited">

            <div class="title_part gradient form_panel" [ngClass]="{ 'open': isOpenPanel('accessDisplayOption'), 'closed': !isOpenPanel('accessDisplayOption') }" (click)="togglePanelOpening('accessDisplayOption')">
                <div [ngClass]="{ 'valid': isValidPanel('accessDisplayOption'), 'invalid': !isValidPanel('accessDisplayOption') }"></div>
                {{ 'offer.access.display.option.title.value' | translate }}
            </div>

            @if(isOpenPanel('accessDisplayOption')) {

                <!-- Affichage des distance -->

                <div class="ligne_form row marges">

                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'offer.access.program.option.display.title.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="displayTransportDuration" class="form-control" id="displayTransportDurationYes">
                                <label for="displayTransportDurationYes">{{'yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="displayTransportDuration" class="form-control" id="displayTransportDurationNo">
                                <label for="displayTransportDurationNo">{{'no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Prévisualisation -->

                @if(form.get('displayTransportDuration').value) {

                    <div class="ligne_form">
                        <button class="btn_cta btn_little" type="button" (click)="hydrateTransportCalculations()">
                            {{ 'offer.access.program.option.display.preview.action.value' | translate }}
                        </button>
                    </div>

                    @if(transportCalculations.length) {

                        <div class="ligne_form row marges">

                            @if(form.get('startLocationSameAsEndLocation').value) {

                                <!-- Début / fin de programme -->

                                @if(isSelectedTransportType('train-station')) {

                                    <div class="col_3 transport_calculation_item">
                                        <p><strong>{{ 'trainStation.startAndEnd.value' | translate}} :</strong><br>{{ getTransportCalculation(true, true, 'train-station').transport.label }}</p>
                                        <app-core-offer-location-transport-calculation-thumbnail [offerLocationTransport]="getTransportCalculation(true, true, 'train-station')"></app-core-offer-location-transport-calculation-thumbnail>
                                    </div>
                                }

                                @if(isSelectedTransportType('airport')) {

                                    <div class="col_3 transport_calculation_item">
                                        <p><strong>{{ 'airport.startAndEnd.value' | translate}} :</strong><br>{{ getTransportCalculation(true, true, 'airport').transport.label }}</p>
                                        <app-core-offer-location-transport-calculation-thumbnail [offerLocationTransport]="getTransportCalculation(true, true, 'airport')"></app-core-offer-location-transport-calculation-thumbnail>
                                    </div>
                                }

                            } @else {

                                <!-- Début de programme -->

                                @if(isSelectedTransportType('train-station')) {

                                    <div class="col_3 transport_calculation_item">
                                        <p><strong>{{ 'trainStation.start.value' | translate}} :</strong><br>{{ getTransportCalculation(true, false, 'train-station').transport.label }}</p>
                                        <app-core-offer-location-transport-calculation-thumbnail [offerLocationTransport]="getTransportCalculation(true, false, 'train-station')"></app-core-offer-location-transport-calculation-thumbnail>
                                    </div>
                                }

                                @if(isSelectedTransportType('airport')) {

                                    <div class="col_3 transport_calculation_item">
                                        <p><strong>{{ 'airport.start.value' | translate}} :</strong><br>{{ getTransportCalculation(true, false, 'airport').transport.label }}</p>
                                        <app-core-offer-location-transport-calculation-thumbnail [offerLocationTransport]="getTransportCalculation(true, false, 'airport')"></app-core-offer-location-transport-calculation-thumbnail>
                                    </div>
                                }

                                <!-- Fin de programme -->

                                @if(isSelectedTransportType('train-station')) {

                                    <div class="col_3 transport_calculation_item">
                                        <p><strong>{{ 'trainStation.end.value' | translate}} :</strong><br>{{ getTransportCalculation(false, true, 'train-station').transport.label }}</p>
                                        <app-core-offer-location-transport-calculation-thumbnail [offerLocationTransport]="getTransportCalculation(false, true, 'train-station')"></app-core-offer-location-transport-calculation-thumbnail>
                                    </div>
                                }

                                @if(isSelectedTransportType('airport')) {

                                    <div class="col_3 transport_calculation_item">
                                        <p><strong>{{ 'airport.end.value' | translate}} :</strong><br>{{ getTransportCalculation(false, true, 'airport').transport.label }}</p>
                                        <app-core-offer-location-transport-calculation-thumbnail [offerLocationTransport]="getTransportCalculation(false, true, 'airport')"></app-core-offer-location-transport-calculation-thumbnail>
                                    </div>
                                }
                            }

                        </div>
                    }
                }
            }

        </div>

        <!-- Ofrre compatible sans voiture -->

        <div class="form_part limited">

            <div class="title_part gradient form_panel" [ngClass]="{ 'open': isOpenPanel('accessCompatibilityWithoutCar'), 'closed': !isOpenPanel('accessCompatibilityWithoutCar') }" (click)="togglePanelOpening('accessCompatibilityWithoutCar')">
                <div [ngClass]="{ 'valid': isValidPanel('accessCompatibilityWithoutCar'), 'invalid': !isValidPanel('accessCompatibilityWithoutCar') }"></div>
                {{ 'offer.access.compatibility.withoutCar.title.value' | translate }}
            </div>

            @if(isOpenPanel('accessCompatibilityWithoutCar')) {

                <!-- Offre compatible sans voiture -->

                <div class="ligne_form row marges">

                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'offer.access.carFreeCompatible.title.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="isCarFreeCompatible" class="form-control" id="isCarFreeCompatibleYes">
                                <label for="isCarFreeCompatibleYes">{{'yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="isCarFreeCompatible" class="form-control" id="isCarFreeCompatibleNo">
                                <label for="isCarFreeCompatibleNo">{{'no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>

                </div>
            }

        </div>

    </ng-container>

</ng-template>

<!-- Gestion du SEO -->

<ng-template #seoManagement>

    <ng-container [formGroup]="form">

        <ng-container formGroupName="seo">

            <div class="content_tab">

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <div class="deletable_information">
                            <p [innerHTML]="'offer.form.seo.help.value' | translate"></p>
                        </div>
                    </div>
                </div>

                <!-- Index / Follow -->

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'offer.seo.follow.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="follow" class="form-control" id="isSeoFollowYes">
                                <label for="isSeoFollowYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="follow" class="form-control" id="isSeoFollowNo">
                                <label for="isSeoFollowNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                            <span class="message-help">
                                <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.seo.follow.help.value' | translate }}
                            </span>
                            @if(seoControl.get('follow').errors && (seoControl.get('follow').dirty || seoControl.get('follow').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(seoControl.get('follow').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="ligne_form row marges">
                    <div class="col_12">
                        <div class="mat-tab-translations" [ngClass]="seoTranslationBuilder.itemsControl|translationPanelValidationClass:['slug', 'metaTitle', 'metaDescription']">

                            <ng-container formArrayName="translations">

                                <mat-tab-group [@.disabled]="true">

                                    @for (locale of offerService.displayedLocales$.getValue(); track locale) {
                                        <div>
                                            <mat-tab label="{{seoTranslationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="seoTranslationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['slug', 'metaTitle', 'metaDescription']">
                                                <ng-container [formGroupName]="seoTranslationBuilder.getItemIndexByLocale(locale)">

                                                    <!-- Slug -->

                                                    <div class="row marges ligne_form">
                                                        <div class="col_12">
                                                            <div class="form-group">
                                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="slug" id="seo-slug-{{ seoTranslationBuilder.getItemIndexByLocale(locale) }}" required="required">
                                                                <label for="seo-slug-{{ seoTranslationBuilder.getItemIndexByLocale(locale) }}">{{ 'offer.seo.slug.value' | translate }}</label>
                                                                <span class="message-help">
                                                                    <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.seo.slug.help.value' | translate }}
                                                                </span>
                                                                @if(seoTranslationBuilder.getItemControlByLocale(locale).get('slug').errors && (seoTranslationBuilder.getItemControlByLocale(locale).get('slug').dirty || seoTranslationBuilder.getItemControlByLocale(locale).get('slug').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(seoTranslationBuilder.getItemControlByLocale(locale).get('slug').errors.isRequired) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                            @if(seoTranslationBuilder.getItemControlByLocale(locale).get('slug').errors.pattern) {
                                                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row marges ligne_form">
                                                        <div class="col_12">

                                                            <!-- Meta Title -->

                                                            <div class="form-group">
                                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="metaTitle" id="seo-meta-title-{{ seoTranslationBuilder.getItemIndexByLocale(locale) }}" required="required">
                                                                <label for="seo-meta-title-{{ seoTranslationBuilder.getItemIndexByLocale(locale) }}">{{ 'offer.seo.meta.title.value' | translate }}</label>
                                                                <span class="message-help">
                                                                    <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.seo.meta.title.help.value' | translate }}
                                                                </span>
                                                                @if(seoTranslationBuilder.getItemControlByLocale(locale).get('metaTitle').errors && (seoTranslationBuilder.getItemControlByLocale(locale).get('metaTitle').dirty || seoTranslationBuilder.getItemControlByLocale(locale).get('metaTitle').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(seoTranslationBuilder.getItemControlByLocale(locale).get('metaTitle').errors.required) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row marges ligne_form">
                                                        <div class="col_12">

                                                            <!-- Meta Description -->

                                                            <div class="form-group">
                                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="metaDescription" id="seo-meta-description-{{ seoTranslationBuilder.getItemIndexByLocale(locale) }}" required="required">
                                                                <label for="seo-meta-description-{{ seoTranslationBuilder.getItemIndexByLocale(locale) }}">{{ 'offer.seo.meta.description.value' | translate }}</label>
                                                                <span class="message-help">
                                                                    <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.seo.meta.description.help.value' | translate }}
                                                                </span>
                                                                @if(seoTranslationBuilder.getItemControlByLocale(locale).get('metaDescription').errors && (seoTranslationBuilder.getItemControlByLocale(locale).get('metaDescription').dirty || seoTranslationBuilder.getItemControlByLocale(locale).get('metaDescription').touched)) {
                                                                    <mat-error>
                                                                        <div class="invalid-feedback">
                                                                            @if(seoTranslationBuilder.getItemControlByLocale(locale).get('metaDescription').errors.required) {
                                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                                            }
                                                                            @if(seoTranslationBuilder.getItemControlByLocale(locale).get('metaDescription').errors.maxlength) {
                                                                                <div>{{ 'form.control.error.maxLength.value' | translate: { maxLength: 255 } }}</div>
                                                                            }
                                                                        </div>
                                                                    </mat-error>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </mat-tab>
                                        </div>
                                    }
                                </mat-tab-group>

                            </ng-container>
                        </div>
                    </div>
                </div>

            </div>

        </ng-container>

    </ng-container>

</ng-template>

<!-- Commentaires internes BtoB -->

<ng-template #internalComments>

    <ng-container [formGroup]="form">

        <div class="content_tab">

            @if(translationBuilder.items.length) {

                <div class="form_part">

                    <p class="title_part">{{ 'offer.form.title.salesPitch.value' | translate }}</p>

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group col_content y_items_center">
                                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.salesPitch.info.value' | translate }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="row ligne_form">
                        <div class="mat-tab-translations" [ngClass]="translationBuilder.itemsControl|translationPanelValidationClass:['salesPitch']">

                            <ng-container formArrayName="translations">

                                <mat-tab-group [@.disabled]="true">
                                    @for (locale of offerService.displayedLocales$.getValue(); track locale) {
                                        <div>
                                            <mat-tab label="{{translationBuilder.getLocaleLabel(locale) | translate }}" [labelClass]="translationBuilder.getItemControlByLocale(locale)|translationTabValidationClass:['salesPitch']">
                                                <ng-container [formGroupName]="translationBuilder.getItemIndexByLocale(locale)">
                                                    <div class="row marges ligne_form">
                                                        <div class="col_12">
                                                            <div class="form-group">
                                                                <app-ckeditor [form]="translationBuilder.getItemControlByLocale(locale)" [config]="salesPitchEditorConfig"></app-ckeditor>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </mat-tab>
                                        </div>
                                    }
                                </mat-tab-group>
                            </ng-container>

                        </div>
                    </div>
                </div>
            }

            <!-- Offre en vigilance -->

            <div class="form_part">

                <p class="title_part">{{ 'offer.form.title.vigilance.value' | translate }}</p>

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group col_content y_items_center">
                            <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.vigilance.info.value' | translate }}</span>
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{'offer.vigilance.put.action.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="isOnAlert" class="form-control" id="isOnAlertYes">
                                <label for="isOnAlertYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="isOnAlert" class="form-control" id="isOnAlertNo">
                                <label for="isOnAlertNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                            @if(form.get('isOnAlert').errors && (form.get('isOnAlert').dirty || form.get('isOnAlert').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('isOnAlert').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <!-- Commentaire -->

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <textarea placeholder=" " class="form-control" formControlName="commentAlert" id="commentAlert"></textarea>
                            <label for="commentAlert">{{'offer.vigilance.comment.value' | translate}}</label>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </ng-container>

</ng-template>

<!-- Options -->

<ng-template #options>

    <ng-container [formGroup]="form">

        <div class="ligne_form row marges">

            <div class="col_12 y_items_center">

                <div class="form-group">
                    <mat-select formControlName="options" multiple>
                        @for ((option of options$ | async); track option) {
                            <mat-option [value]="option.id">
                                {{ translationService.getFallbackTranslation(option.translations).name }}
                            </mat-option>
                        }
                    </mat-select>
                </div>

            </div>

        </div>

    </ng-container>

</ng-template>

<!-- Paramètres tarifs -->

<ng-template #pricingData>

    <ng-container [formGroup]="form">

        <div class="content_tab">

            <div class="row marges ligne_form">
                @if(!form.get('onRequest').value) {
                    <div class="col_12">
                        <div class="price_config_description added_bottom_margin">
                            <p [innerHTML]="'offer.price.configuration.description.value'|translate"></p>
                        </div>
                    </div>
                }
                <div class="col_12">

                    <!-- Offre sur devis -->

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'offer.quotation.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="onRequest" class="form-control" id="onRequestNo">
                                    <label for="onRequestNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="onRequest" class="form-control" id="onRequestYes">
                                    <label for="onRequestYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if(!!form.get('onRequest').value) {

                        <!-- Tarif à partir de -->

                        <div class="ligne_form">
                            <div class="form-group">
                                <label>{{'offer.internalStartFromPriceTTC.title.value' | translate}}</label>
                                <div class="form-group">
                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="internalStartFromPriceTTC" id="internalStartFromPriceTTC" [control]="form.get('internalStartFromPriceTTC')">
                                    <label for="internalStartFromPriceTTC">{{'offer.internalStartFromPriceTTC.value' | translate}}</label>
                                    @if(form.get('internalStartFromPriceTTC').errors && (form.get('internalStartFromPriceTTC').dirty || form.get('internalStartFromPriceTTC').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(form.get('internalStartFromPriceTTC').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(form.get('internalStartFromPriceTTC').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.internalStartFromPriceTTC.help.value' | translate }}
                                    </span>
                                </div>
                            </div>

                        </div>

                        <!-- Base de X participants -->

                        <div class="ligne_form">
                            <div class="form-group">
                                <label>{{'offer.startFromPriceBasedOnParticipantCount.value' | translate}}</label>
                                <div class="form-group">
                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="startFromPriceBasedOnParticipantCount" id="startFromPriceBasedOnParticipantCount" [control]="form.get('startFromPriceBasedOnParticipantCount')">
                                    <label for="startFromPriceBasedOnParticipantCount">{{'offer.startFromPriceBasedOnParticipantCount.value' | translate}}</label>
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.startFromPriceBasedOnParticipantCount.help.value' | translate }}
                                    </span>
                                </div>
                            </div>

                        </div>
                    }

                    <!-- Sélection de la devise -->

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <select class="form-control" id="currency" formControlName="currency" [required]="!form.get('onRequest').value || (form.get('internalStartFromPriceTTC').value !== null && form.get('internalStartFromPriceTTC').value !== '')">
                                    <option value=""></option>
                                    @for (currency of currencies; track currency) {
                                        <option [ngValue]="currency.id">
                                            {{ translationService.getFallbackTranslation(currency.translations).label }} ({{ currency.code }})
                                        </option>
                                    }
                                </select>
                                <label [ngClass]="!form.get('onRequest').value || (form.get('internalStartFromPriceTTC').value !== null && form.get('internalStartFromPriceTTC').value !== '') ? 'required' : ''" for="currency">{{ 'currency.value' | translate }}</label>
                                @if(form.get('currency').errors && (form.get('currency').dirty || form.get('currency').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('currency').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    @if(!form.get('onRequest').value) {

                        <!-- Préférence d'affichage des tarifs -->

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{'offer.displayPrice.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="'HT'" formControlName="displayPrice" class="form-control" id="isDisplayPriceHT">
                                        <label for="isDisplayPriceHT">{{'offer.displayPrice.ht.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="'TTC'" formControlName="displayPrice" class="form-control" id="isDisplayPriceTTC">
                                        <label for="isDisplayPriceTTC">{{'offer.displayPrice.ttc.value' | translate}}</label>
                                    </div>
                                    @if(form.get('displayPrice').errors && (form.get('displayPrice').dirty || form.get('displayPrice').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(form.get('displayPrice').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.displayPrice.description.value' | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Sélection du montant de la TVA -->

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label for="vatPercent">{{'tva.percent.value' | translate}}</label>
                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="vatPercent" id="vatPercent">
                                        <label for="vatPercent">{{'tva.percent.value' | translate}}</label>
                                        @if(form.get('vatPercent').errors && (form.get('vatPercent').dirty || form.get('vatPercent').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(form.get('vatPercent').errors.pattern) {
                                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <!-- Mark-up -->

                    <div class="ligne_form">
                        <div class="form-group">
                            <label>{{'markup.define.value' | translate}}</label>
                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="markup" id="markup" appInputTextParseMarkup [control]="form.get('markup')">
                                <label for="markup">{{'markup.form.value' | translate}}</label>
                                @if(form.get('markup').errors && (form.get('markup').dirty || form.get('markup').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('markup').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(form.get('markup').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                            @if(form.get('markup').errors.min) {
                                                <div>{{ 'markup.validator.min.value' | translate:{min: minMarkupPercent} }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                                <span class="message-help" [ngClass]="form.get('markup').value < defaultMarkupPercent ? 'error' : ''">
                                        <mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.markup.help.recommendations.value' | translate }}
                                    </span>
                                <span class="message-help" [innerHTML]="'offer.markup.help.value' | translate"></span>
                            </div>
                        </div>

                    </div>

                    <!-- Fuseau horaire -->

                    <div class="ligne_form">

                            <div class="form-group">
                                <app-core-timezone-select [form]="form" [required]="true"></app-core-timezone-select>
                            </div>

                    </div>
                    <br/>

                </div>

                @if(!form.get('onRequest').value) {

                    <div class="col_12">

                        <div class="ligne_form">
                            <div class="form-group">
                                <label>{{'offer.quotation.form.calendar.incomplete.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="allowBookingRequest" class="form-control" id="allowBookingRequestNo">
                                    <label for="allowBookingRequestNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="allowBookingRequest" class="form-control" id="allowBookingRequestYes">
                                    <label for="allowBookingRequestYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                            </div>
                        </div>

                    </div>
                }

            </div>
        </div>
    </ng-container>

</ng-template>

<!-- Bon cadeaux -->

<ng-template #giftVoucherData >

    <ng-container [formGroup]="form">

        <div class="form_part">

            <div class="ligne_form row marges">

                <div class="col_12 col_md_6">

                    <!-- Offre proposé en Bon cadeau -->

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'offer.form.fields.giftVoucher.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="enableGiftVoucher" class="form-control" id="enableGiftVoucherNo">
                                    <label for="enableGiftVoucherNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="true" [attr.disabled]="form.get('onRequest').value ? true : null" formControlName="enableGiftVoucher" class="form-control" id="enableGiftVoucherYes">
                                    <label for="enableGiftVoucherYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                @if(form.get('onRequest').value) {
                                    <div class="message">
                                        <span class="message-help">
                                            <mat-icon class="tooltip_icon">info</mat-icon>
                                            {{ 'offer.form.fields.giftVoucher.onRequest.value' | translate }}
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    @if(form.get('enableGiftVoucher').value && !society.isValidMangoPayAccount) {

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon>
                                    {{ 'offer.giftVoucher.mangopay.validation.required.value' | translate }}
                                </span>
                                </div>
                            </div>
                        </div>
                    }

                    <!-- Tarifs adultes -->

                    @if(form.get('enableGiftVoucher').value) {

                        <div class="row marges ligne_form" formGroupName="giftVoucher">

                            @if(isSelectedOfferPricePublic('adult')) {

                                <div class="col_6">
                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="adultPriceTTC" id="adultPriceTTC" required appInputTextParsePrice [control]="giftVoucherControl.get('adultPriceTTC')">
                                        <label for="adultPriceTTC">{{ 'offer.giftVoucher.price.adult.ttc.value' | translate: {currency: '€'} }}</label>
                                        <mat-error>
                                            @if(giftVoucherControl.get('adultPriceTTC').invalid && (giftVoucherControl.get('adultPriceTTC').dirty || giftVoucherControl.get('adultPriceTTC').touched)) {
                                                <div class="invalid-feedback">
                                                    @if(giftVoucherControl.get('adultPriceTTC').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                    @if(giftVoucherControl.get('adultPriceTTC').errors.pattern) {
                                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                    }
                                                </div>
                                            }
                                        </mat-error>
                                    </div>
                                </div>
                            }

                            @if(isSelectedOfferPricePublic('child')) {

                                <div class="col_6">
                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="childPriceTTC" id="childPriceTTC" required appInputTextParsePrice [control]="giftVoucherControl.get('childPriceTTC')">
                                        <label for="childPriceTTC">{{'offer.giftVoucher.price.child.ttc.value' | translate: {currency: '€'} }}</label>
                                        @if(giftVoucherControl.get('childPriceTTC').invalid && (giftVoucherControl.get('childPriceTTC').dirty || giftVoucherControl.get('childPriceTTC').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(giftVoucherControl.get('childPriceTTC').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                    @if(giftVoucherControl.get('childPriceTTC').errors.pattern) {
                                                        <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                            }

                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_6">
                                <div class="form-group">
                                <span class="message-help">
                                    <mat-icon class="tooltip_icon">info</mat-icon>
                                    {{ 'offer.prices.help.value' | translate }}
                                </span>
                                </div>
                            </div>
                        </div>
                    }

                </div>

            </div>

        </div>

        <div class="form_part">

            @if(form.get('enableGiftVoucher').value) {

                <ng-container formGroupName="giftVoucher">

                    <!--   Distribution du bon cadeaux  -->
                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'giftVoucher.template.type.value' | translate}}</label>

                                @for (giftVoucherType of offerGiftVoucherTypes; track giftVoucherType) {
                                    <div class="checkbox inline">
                                        <input type="checkbox" id="{{giftVoucherType.type}}" [value]="giftVoucherType.type" [checked]="isSelectedGiftVoucherType(giftVoucherType.type)" (change)="handleGiftVoucherType($event)">
                                        <label for="{{giftVoucherType.type}}">{{ giftVoucherType.label | translate }}</label>
                                    </div>
                                }
                                @if(giftVoucherControl.get('types').invalid && (giftVoucherControl.get('types').dirty || giftVoucherControl.get('types').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(giftVoucherControl.get('types').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                </ng-container>
            }

        </div>

        <!-- Offre proposé en vente en ligne -->

        <div class="form_part">

            <div class="ligne_form row marges">

                <div class="col_12 col_md_6">

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                <label>{{'offer.form.fields.onlineSale.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="enableOnlineSale" class="form-control" id="enableOnlineSaleNo">
                                    <label for="enableOnlineSaleNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="true" [attr.disabled]="form.get('onRequest').value ? true : null" formControlName="enableOnlineSale" class="form-control" id="enableOnlineSaleYes">
                                    <label for="enableOnlineSaleYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                @if(isOrchestra) {
                                    <div class="message">
                                        <span class="message-help">
                                            <mat-icon class="tooltip_icon">info</mat-icon>
                                            {{ 'offer.form.fields.onlineSale.orchestra.info.value' | translate }}
                                        </span>
                                    </div>
                                }
                                @if(form.get('onRequest').value) {
                                    <div class="message">
                                        <span class="message-help">
                                            <mat-icon class="tooltip_icon">info</mat-icon>
                                            {{ 'offer.form.fields.onlineSale.onRequest.value' | translate }}
                                        </span>
                                    </div>
                                }
                                <div class="message">
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>
                                        {{ 'offer.form.fields.onlineSale.info.value' | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        @if(form.get('enableOnlineSale').value) {

            <div class="form_part">

                <div class="ligne_form row marges">

                    <div class="col_12 col_md_6">

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{ 'offer.stock.management.type.selection.value' | translate }}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="'dissociated'" formControlName="stockManagementType" class="form-control" id="stockManagementTypeDissociated">
                                        <label for="stockManagementTypeDissociated">{{ 'offer.stock.management.type.dissociated.value' | translate }}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="'common'" formControlName="stockManagementType" class="form-control" id="stockManagementTypeCommon">
                                        <label for="stockManagementTypeCommon">{{ 'offer.stock.management.type.common.value' | translate }}</label>
                                    </div>
                                    <div class="message">
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'offer.stock.management.type.info.value' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        }

    </ng-container>

</ng-template>
